var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellFilled = function SvgBellFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26172 8.61064C4.73379 4.83406 7.94416 2 11.7501 2C15.5561 2 18.7665 4.83406 19.2386 8.61064L20.2275 16.522C20.4251 18.1033 19.1921 19.5 17.5985 19.5H16.2375L16.1852 19.6178C15.4062 21.3705 13.6681 22.5 11.7501 22.5C9.83211 22.5 8.09402 21.3705 7.31505 19.6178L7.2627 19.5H5.90174C4.30813 19.5 3.07514 18.1033 3.2728 16.522L4.26172 8.61064ZM14.5449 19.5H8.95531C9.5695 20.4265 10.6141 21 11.7501 21C12.8861 21 13.9307 20.4265 14.5449 19.5Z"
  })));
};
export default SvgBellFilled;